import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import GroupShopDepositTableHeadGroup from '../../components/molecules/GroupShopDepositTableHeadGroup';
import GroupShopDepositTableBodyGroup from '../../components/molecules/GroupShopDepositTableBodyGroup';
import { addRelationShop, getShops } from '../../actions/Shop';
import { sendMailDepositDetailByShopMonth } from '../../actions/Deposits';
import { sendLogin } from '../../auth/Auth';
// import ConfirmDialog from '../../components/molecules/ConfirmDialog';
import ProgressDialog from '../../components/molecules/ProgressDialog';
// import ContentDialog from '../../components/molecules/ContentDialog';

const styles = {
  scrollTable: {
    // maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      // shops: state.shops.shops,
      accessibleShops: state.shops.accessibleShops,
      totalCount: state.shops.totalCount,
      offset: state.shops.offset
    }),
    dispatch => ({
      actions: bindActionCreators(
        { addRelationShop, getShops, sendMailDepositDetailByShopMonth },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isRelationSuccess', 'updateIsRelationSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('shopName', 'setShopName', ''),
  withState('message', 'setMessage', ''),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', 'shopId'),
  withState('page', 'setPage', 0),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    page,
    totalCount,
    shops,
    rowsPerPage,
    order,
    orderBy,
    handleRequestSort,
    loading,
    updateLoading,
    resultMessage,
    setResultMessage,
    currencyFormat,
    openProgress,
    updateOpenProgress,
    currentMonthYear,
    fromTopPageGroup,
    isFukuoka,
    isTable2
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    const handleSendMailByShop = async (monthValue, shopIdValue) => {
      updateLoading(true);
      updateOpenProgress(true);
      const result = await actions
        .sendMailDepositDetailByShopMonth(monthValue, shopIdValue)
        .then(data => checkSession(data));
      if (result.type === 'SEND_MAIL_DEPOSIT_DETAIL_BY_SHOP_MONTH_SUCCESS') {
        setResultMessage('入金詳細のメールを送りました。');
        updateLoading(false);
        // updateOpenProgress(false);
      } else {
        setResultMessage(
          isFukuoka
            ? '精算詳細のメールが送れません。もう一度お試しください。'
            : '入金詳細のメールが送れません。もう一度お試しください。'
        );
        updateLoading(false);
        // updateOpenProgress(false);
      }
    };

    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <GroupShopDepositTableHeadGroup
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              fromTopPageGroup={fromTopPageGroup}
              isFukuoka={isFukuoka}
              isTable2={isTable2}
            />
            <GroupShopDepositTableBodyGroup
              shops={shops}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              order={order}
              orderBy={orderBy}
              currencyFormat={currencyFormat}
              currentMonthYear={currentMonthYear}
              handleSendMailByShop={handleSendMailByShop}
              fromTopPageGroup={fromTopPageGroup}
              isFukuoka={isFukuoka}
              isTable2={isTable2}
            />
          </Table>
        </div>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
